import { render, staticRenderFns } from "./PartRolePermissions.vue?vue&type=template&id=739682ec"
import script from "./PartRolePermissions.vue?vue&type=script&setup=true&lang=js"
export * from "./PartRolePermissions.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('739682ec')) {
      api.createRecord('739682ec', component.options)
    } else {
      api.reload('739682ec', component.options)
    }
    module.hot.accept("./PartRolePermissions.vue?vue&type=template&id=739682ec", function () {
      api.rerender('739682ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/role/components/PartRolePermissions.vue"
export default component.exports